<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-taps', params: {id: accountId}}">
              {{ $t('accountTap.detailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ resourceId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('accountTap.detailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="details">
              <tap-details :details="details"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import TapDetails from 'src/components/Tap/TapDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountTap",
  components: {
    TapDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    resourceId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountTap']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountTap({accountID: this.accountId, resourceID: this.resourceId});
  },
  computed: {
    ...mapState({
      loading: state => state.account_tap.loading,
      details: state => state.account_tap.data,
    }),
  },
}
</script>

